import { Coins, Plus, Wallet } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { Card } from '@/shared/components/ui/card'
import type { BusinessBalance } from '../hooks/useBusinessBalance'

interface BalanceCardProps {
  balance: BusinessBalance | null
  onPurchase: () => void
  disabled?: boolean
}

/**
 * Tarjeta con el balance de créditos del negocio + recargas disponibles por
 * canal, y el CTA "Comprar crédito".
 */
export function BalanceCard({ balance, onPurchase, disabled }: BalanceCardProps) {
  const total = balance?.total ?? 0
  const channels = balance?.channels ?? []

  return (
    <Card>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="grid h-11 w-11 place-items-center rounded-xl bg-brand-soft text-brand">
            <Wallet className="h-5 w-5" />
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtle">
              Balance de créditos
            </p>
            <p className="font-mono text-3xl font-bold leading-tight tracking-tight text-ink">
              {total.toLocaleString('es-CU')}
            </p>
            <p className="mt-0.5 text-xs text-ink-muted">créditos disponibles</p>
          </div>
        </div>

        <Button variant="primary" onClick={onPurchase} disabled={disabled}>
          <Plus className="h-4 w-4" />
          Comprar crédito
        </Button>
      </div>

      {channels.length > 0 && (
        <div className="mt-5 border-t border-line pt-4">
          <p className="mb-2.5 text-[11px] font-semibold uppercase tracking-wide text-ink-subtle">
            Recargas disponibles por canal
          </p>
          <div className="flex flex-wrap gap-2">
            {channels.map((c) => (
              <span
                key={c.deliveryChanel}
                className="inline-flex items-center gap-2 rounded-full border border-line bg-surface px-3 py-1.5 text-xs"
              >
                <Coins className="h-3.5 w-3.5 text-accent" />
                <span className="font-medium text-ink">{c.deliveryChanel}</span>
                <span className="font-mono font-semibold text-ink">
                  {c.remainQuantity.toLocaleString('es-CU')}
                </span>
              </span>
            ))}
          </div>
        </div>
      )}
    </Card>
  )
}
